import { HTMLAttributes, ReactNode, forwardRef } from 'react';

import { container } from './section-container.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    className?: string;
    id?: string;
}

export const SectionContainer = forwardRef<HTMLDivElement, Props>(({ children, className, ...rest }, ref) => (
    <section ref={ref} className={`${container} ${className}`} {...rest}>
        {children}
    </section>
));
